<template>
  <span
    class="compare-jobs-linked-indicator"
    @click.stop
  >
    <DpplDarkTooltip
      :tooltip-placement="tooltipPlacement"
      :tooltip-offset="12"
      light-mode
      teleport
    >
      <template #activator="{ onMouseenter, onMouseleave }">
        <span
          class="compare-jobs-linked-indicator-activator"
          aria-label="Linked profile"
          @mouseenter="onMouseenter"
          @mouseleave="onMouseleave"
        >
          <v-icon
            size="16"
            icon="mdi-link-variant"
            color="iconDefault"
          />
        </span>
      </template>
      <template #tooltip-content>
        <p class="compare-jobs-linked-indicator-tooltip text-body-3 text-textLight">
          {{ tooltip }}
        </p>
      </template>
    </DpplDarkTooltip>
  </span>
</template>

<script setup>
import DpplDarkTooltip from '@/components/datapeople/DpplDarkTooltip.vue';

defineProps({
  tooltip: {
    type: String,
    required: true,
  },
  tooltipPlacement: {
    type: String,
    default: 'bottom',
  },
});
</script>

<style scoped lang="less">
.compare-jobs-linked-indicator {
  display: inline-flex;
  flex-shrink: 0;
  line-height: 0;
}

.compare-jobs-linked-indicator-activator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
}

.compare-jobs-linked-indicator-tooltip {
  margin: 0;
}
</style>
